import React from 'react';
import './portafolio.scss';
import CardPortfolio from '../../components/CardPortfolio/CardPortfolio';
import ContactCard from '../../components/Contact/ContactCard';
import Botanas from '../../assets/portfolioImages/Botanas.jpg';
import clinica from '../../assets/portfolioImages/Clinica.png';
import crisanto from '../../assets/portfolioImages/Crisanto.png';
import fajas from '../../assets/portfolioImages/Fajas.png';
import gentis from '../../assets/portfolioImages/Gentis.png';


function Portafolio () {
    return(
        <div className="container">
            <div className="row d-flex justify-content-center">
                <CardPortfolio 
                    text="Botanas el gorila"
                    image={ Botanas }
                    link={ `https://botanasgorila.web.app/` }
                    iconFont={<i className="fab fa-html5"></i>}
                    iconCss={<i className="fab fa-css3-alt"></i>}
                    iconBots={<i className="fab fa-bootstrap"></i>}
                />
                <CardPortfolio
                    text="FajaColombiana"
                    link={`https://www.fajacolombiana.com.mx/`}
                    image={ fajas }
                    iconFont={<i className="fab fa-html5"></i>}
                    iconCss={<i className="fab fa-css3-alt"></i>}
                    iconPhp= {<i className="fab fa-php"></i> }
                    iconWordp={ <i className="fab fa-wordpress"></i>}
                
                />
                <CardPortfolio 
                    text="Gentis"
                    image={gentis}
                    link={`https://gentis.com.mx`}
                    iconReact={ <i className="fab fa-react"></i>}
                    iconNodejs={<i className="fab fa-node-js"></i>}
                />
                <CardPortfolio 
                    text="Clinica Pie Salud"
                    image={clinica}
                    link={ `https://clinicapodologicapiesalud.web.app/` }
                    iconFont={<i className="fab fa-html5"></i>}
                    iconCss={<i className="fab fa-css3-alt"></i>}
                    iconBots={<i className="fab fa-bootstrap"></i>}
                />
            
                <CardPortfolio 
                    text="Crisanto Seguros"
                    link={ `https://crisantoseguros.web.app/` }
                    image={crisanto}
                    iconFont={<i className="fab fa-html5"></i>}
                    iconCss={<i className="fab fa-css3-alt"></i>}
                    iconBots={<i className="fab fa-bootstrap"></i>}
                    
                />
                <ContactCard />
            </div>
        </div>
    )
}

export default Portafolio;